import { RESET_STATE } from 'store/global/actions';

import { FEED_PULLS_ACTION_TYPE } from '../actions';
import {
  EMPTY_FEED_PULLS,
  EMPTY_PULL_GRID,
  EMPTY_PULL_SPEC_POOLS,
  EMPTY_PULL_SRP_MATRIX,
} from '../marginCenter.constants';

import { isStaleResponse, keepSamePullData } from './feedPulls.reducer.utils';

const initialState = {
  data: EMPTY_FEED_PULLS,
  isLoading: false,
  grid: EMPTY_PULL_GRID,
  srpMatrix: EMPTY_PULL_SRP_MATRIX,
  specPools: EMPTY_PULL_SPEC_POOLS,
};

const feedPullsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FEED_PULLS_ACTION_TYPE.SET_FEED_PULLS_LOADING:
      return { ...state, isLoading: payload };

    case FEED_PULLS_ACTION_TYPE.GET_FEED_PULLS:
      return { ...state, data: payload ?? EMPTY_FEED_PULLS, isLoading: false };

    case FEED_PULLS_ACTION_TYPE.SET_PULL_GRID_LOADING:
      return {
        ...state,
        grid: { pullId: payload, data: null, isLoading: true, errorMessage: null },
      };

    case FEED_PULLS_ACTION_TYPE.GET_PULL_GRID:
      return {
        ...state,
        grid: {
          pullId: payload.pullId,
          data: payload.data ?? null,
          isLoading: false,
          errorMessage: null,
        },
      };

    case FEED_PULLS_ACTION_TYPE.SET_PULL_GRID_ERROR:
      return {
        ...state,
        grid: {
          pullId: payload.pullId,
          data: null,
          isLoading: false,
          errorMessage: payload.errorMessage ?? null,
        },
      };

    case FEED_PULLS_ACTION_TYPE.CLEAR_PULL_GRID:
      return {
        ...state,
        grid: EMPTY_PULL_GRID,
        srpMatrix: EMPTY_PULL_SRP_MATRIX,
        specPools: EMPTY_PULL_SPEC_POOLS,
      };

    case FEED_PULLS_ACTION_TYPE.SET_PULL_SRP_MATRIX_LOADING:
      return {
        ...state,
        srpMatrix: {
          pullId: payload.pullId,
          requestId: payload.requestId,
          data: keepSamePullData(state.srpMatrix, payload.pullId),
          isLoading: true,
          errorMessage: null,
        },
      };

    case FEED_PULLS_ACTION_TYPE.GET_PULL_SRP_MATRIX:
      return isStaleResponse(state.srpMatrix, payload)
        ? state
        : {
            ...state,
            srpMatrix: {
              ...state.srpMatrix,
              data: payload.data ?? null,
              isLoading: false,
              errorMessage: null,
            },
          };

    case FEED_PULLS_ACTION_TYPE.SET_PULL_SRP_MATRIX_ERROR:
      return isStaleResponse(state.srpMatrix, payload)
        ? state
        : {
            ...state,
            srpMatrix: {
              ...state.srpMatrix,
              isLoading: false,
              errorMessage: payload.errorMessage ?? null,
            },
          };

    case FEED_PULLS_ACTION_TYPE.SET_PULL_SPEC_POOLS_LOADING:
      return {
        ...state,
        specPools: {
          pullId: payload.pullId,
          requestId: payload.requestId,
          data: keepSamePullData(state.specPools, payload.pullId),
          isLoading: true,
          errorMessage: null,
        },
      };

    case FEED_PULLS_ACTION_TYPE.GET_PULL_SPEC_POOLS:
      return isStaleResponse(state.specPools, payload)
        ? state
        : {
            ...state,
            specPools: {
              ...state.specPools,
              data: payload.data ?? null,
              isLoading: false,
              errorMessage: null,
            },
          };

    case FEED_PULLS_ACTION_TYPE.SET_PULL_SPEC_POOLS_ERROR:
      return isStaleResponse(state.specPools, payload)
        ? state
        : {
            ...state,
            specPools: {
              ...state.specPools,
              isLoading: false,
              errorMessage: payload.errorMessage ?? null,
            },
          };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default feedPullsReducer;
